import LineInterface from 'app/interfaces/LineInterface';

export const isMainLine = (line: LineInterface): boolean => line.type === 'Bet';
